module.exports = __webpack_public_path__ + "img/colordrop-cn.4936be9.jpg";